import { Project } from "./Project";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const Projects = z.object({
    projects: Project.array(),
});

export type Projects = z.infer<typeof Projects>;
